import { useCommonT } from '../../i18n'
import { openSearch, useSearchOpenState } from '../../lib/searchOpen'
import { SearchIcon } from '../layout/navIcons'

function isMac(): boolean {
  if (typeof navigator === 'undefined') return false
  return /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)
}

/**
 * The header's search trigger (nav v2). A button that LOOKS like a field: the
 * real input lives in the panel, which portals out of the header. One
 * instance across breakpoints; `field` widens it to the phone top bar's
 * search field (Home, Collection, Decks), otherwise it is an icon on phones.
 */
export default function SearchTrigger({ field }: { field: boolean }) {
  const t = useCommonT()
  const { open } = useSearchOpenState()
  return (
    <button
      type="button"
      onClick={() => openSearch()}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label={t('search.trigger_label')}
      data-testid="search-trigger"
      className={`flex h-10 items-center gap-2 rounded-xl border border-gray-800 bg-gray-900 text-gray-400 transition-colors hover:border-gray-700 hover:text-gray-200 md:h-9 md:w-9 md:justify-center md:px-0 lg:w-64 lg:justify-start lg:px-3 ${
        field ? 'min-w-0 flex-1 px-3 md:flex-none' : 'w-10 justify-center'
      }`}
    >
      <SearchIcon className="w-5 h-5 shrink-0" />
      <span className={`min-w-0 flex-1 truncate text-left text-sm md:hidden lg:inline ${field ? '' : 'hidden'}`}>
        {t('search.placeholder')}
      </span>
      <kbd className="hidden rounded border border-gray-700 px-1.5 py-0.5 text-[11px] text-gray-500 lg:inline">
        {isMac() ? t('search.shortcut_mac') : t('search.shortcut_other')}
      </kbd>
    </button>
  )
}
